<div id="sidebar-wr" class="fixed inset-y-0 left-0 w-64" [ngClass]="{'closed': !displaySidebar, 'opened': displaySidebar, 'mobile': isMobile}">
  <aside class="flex h-full min-h-0 flex-col">
    <div class="w-100 relative" [ngClass]="{'hidden': !isMobile}">
      <button data-testid="sidebar-btn-close" class="reset-btn border-none inline-flex items-center text-base" (click)="closeSidebar()" id="close-nav">
        <img src="../../../../../assets/icons/icon-close-sidebar.svg" width="12">
      </button>
    </div>
    <div id="customer-logo-wr" class="flex flex-col border-b pt-3 pb-2 pr-4 pl-4">
      <div class="flex w-full items-center gap-3 mb-3">
        <span id="logo-mark" data-testid="sidebar-logo-mark" class="shrink-0 flex items-center justify-center">
          @if (brandingLogoUrl) {
            <img data-testid="sidebar-company-logo" [src]="brandingLogoUrl" alt="logo" class="size-full" data-logo="company-logo">
          }
        </span>
        <span data-testid="sidebar-company-name" class="brand-name">{{ companyName }}</span>
        @if (canManageSettings) {
          <div data-testid="sidebar-btn-system-settings" class="flex items-center cursor-pointer" (click)="goToSettings()" (mouseenter)="rotateIcon()">
            <i #settingsIcon class="icon icon-settings" pTooltip="{{ 'CORE_SIDEBAR.COMPANY_SETTINGS' | translate }}"
            tooltipPosition="right"></i>
          </div>
        }
      </div>
    </div>
    <nav data-testid="sidebar-navigation" class="flex flex-1 flex-col overflow-y-auto p-3 ">
      <ul data-testid="sidebar-nav-list" role="list" class="primary-nav flex flex-1 flex-col">
        @for (item of menus; track item; let i = $index) {
          <!-- Single menu item -->
          @if (!item.children.length) {
            <li class="relative py-1" [ngClass]="isActive(item.path) ? 'menuactive' : ''" (click)="onNavClick()">
              <a [routerLink]="[item.path]" [attr.data-testid]="'sidebar-nav-item-' + item.text" class="flex w-full items-center gap-2 rounded-lg px-2.5 py-1 text-left font-normal">
                <i class="{{ item.icon }}" aria-hidden="true"></i>
                <span>{{ item.text | translate }}</span>
              </a>
            </li>
          }
          <!-- Parent menu item with children -->
          @if (item.children.length > 0) {
            <li class="relative py-1 parent-item">
              <button (click)="toggleSubmenu(item)"
                class="flex items-center justify-between w-full py-1 rounded-lg reset-btn"
                [attr.data-testid]="'sidebar-nav-item-' + item.text"
                [ngClass]="{'expanded': item.isExpanded}">
                <div class="flex w-full items-center gap-2 rounded-lg px-1 py-1 text-left font-normal">
                  <i class="{{ item.icon }}" aria-hidden="true"></i>
                  <span>{{ item.text | translate }}</span>
                </div>
                <i class="fas fa-chevron-right text-sm" [ngClass]="{'rotate-90': item.isExpanded}"></i>
              </button>
              <!-- Submenu -->
              <ul class="submenu-wrapper" [ngClass]="{'expanded': item.isExpanded}">
                @for (child of item.children; track child; let j = $index) {
                  <li class="relative child-item" [ngClass]="{'menuactive': isChildActive(child.path)}">
                    <a [routerLink]="[child.path]"  [attr.data-testid]="'sidebar-submenu-item-' + item.text + '-' + child.text"
                      class="flex items-center px-4 py-2 text-sm rounded-lg" (click)="onNavClick()">
                      <!-- <i [class]="child.icon + ' mr-3 w-5'"></i> -->
                      <span>{{ child.text | translate }}</span>
                    </a>
                  </li>
                }
              </ul>
            </li>
          }
        }
      </ul>
    </nav>

    <!-- prefooter links -->
    <div id="sidebar-footer" class="border-t">
      @if (showUserManualLink || showSupportLink) {
        <ul class="flex flex-1 flex-col">
          @if (showUserManualLink) {
            <li class="relative py-1">
              <a [href]="userManualUrl" target="_blank" rel="noopener noreferrer"
                class="flex w-full items-center gap-2 rounded-lg px-2.5 py-1 text-left font-normal">
                <i aria-hidden="true" class="icon icon-user-manual"></i>
                <span>{{ 'CORE_SIDEBAR.USER_MANUAL' | translate }}</span>
              </a>
            </li>
          }
          @if (showSupportLink) {
            <li class="relative py-1">
              <a [href]="supportUrl" target="_blank" rel="noopener noreferrer"
                class="flex w-full items-center gap-2 rounded-lg px-2.5 py-1 text-left font-normal">
                <i aria-hidden="true" class="icon icon-support"></i>
                <span>{{ 'CORE_SIDEBAR.SUPPORT' | translate }}</span>
              </a>
            </li>
          }
        </ul>
      }

      <app-footer data-testid="sidebar-footer"></app-footer>
    </div>
  </aside>
</div>

